import React from 'react';
import {NavLink, Link} from 'react-router-dom';
import {Popover, Position, PopoverInteractionKind, Callout} from '@blueprintjs/core';
import ScrollContainer from 'react-indiana-drag-scroll'
import $ from 'jquery';
import ReactGA from "react-ga";


class TopHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state =
            {
                opacity: 0.4,
                display: "none",
                selected_source_rss: props.selected_source_rss,
                selectedSource: props.selectedSource,
                selectedSourceFull: '',
                source_active: true,
                dropDownRemoved: true,
                pauseClosing: false,
                user: this.props.user,
                isOpen: false,
                passedTop: false,
                show: true,
                scrollPos: 0,
                openProfileFromMain: this.props.openProfileFromMain
            };


    }

    hideInactiveBar(e) {
        document.getElementsByClassName('inactive-banner')[0].style.display = 'none';
    }

    handleScroll = () => {
        //detecting where is user scrolling
        if (document.querySelector('.side-menu')) {
            if (!document.querySelector('.side-menu').classList.contains('open-menu')) {
                //console.log('position: ', document.body.getBoundingClientRect())
                if (document.body.getBoundingClientRect().top < -15) {
                    //console.log('scrolled more than 90')
                    this.setState({
                        scrollPos: document.body.getBoundingClientRect().top,
                        show: document.body.getBoundingClientRect().top > this.state.scrollPos,
                        passedTop: true
                    })
                } else {
                    //console.log('scrolled less than 90')
                    this.setState(
                        {
                            scrollPos: document.body.getBoundingClientRect().top,
                            show: true,
                            passedTop: false
                        }
                    )


                }
            } else {
                this.setState(
                    {
                        scrollPos: 0,
                        show: true,
                        passedTop: false
                    }
                )
            }
        }
    }

    componentDidMount = async () => {
        window.addEventListener('scroll', this.handleScroll)
        document.addEventListener("click", this.closeProfileSettingsMenu);
        let selectedSourceFull = await this.state.user.sources.data.filter(
            source => {
                // console.log('current source Id : ', source.id)
                // console.log('selectedSource id :', this.state.selectedSource);
                return source.id.toString() === this.state.selectedSource.toString()

            }
        )

        this.setState({
            selectedSource: this.props.selectedSource,
            selectedSourceFull,
            selected_source_rss: this.props.selected_source_rss,
            source_active: this.props.source_active
        });
    }


    componentDidUpdate = async () => {
        if (this.state.openProfileFromMain !== this.props.openProfileFromMain) {
            this.setState({
                openProfileFromMain: this.props.openProfileFromMain
            })
        }
        if (this.state.selected_source_rss !== this.props.selected_source_rss) {
            this.setState({
                selected_source_rss: this.props.selected_source_rss
            });
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            let selectedSourceFull = await this.state.user.sources.data.filter(
                source => {
                    // console.log('current source Id : ', source.id)
                    // console.log('selectedSource id :', this.state.selectedSource);
                    return source.id.toString() === this.props.selectedSource.toString()

                }
            )
            this.setState({
                selectedSource: this.props.selectedSource,
                selectedSourceFull
            });
            localStorage.setItem("source_clicked", JSON.stringify(this.props.selectedSource.toString()));
            // localStorage.setItem("feed_id", JSON.stringify(this.props.selectedSource.toString()));
        }
        if (this.state.source_active !== this.props.source_active) {
            this.setState({
                source_active: this.props.source_active
            });
        }
        if (this.state.user !== this.props.user) {
            //console.info('something changed in user')
            let user = this.props.user
            let selectedSourceFull = await user.sources.data.filter(
                source => {
                    // console.log('current source Id : ', source.id)
                    // console.log('selectedSource id :', this.state.selectedSource);
                    return source.id.toString() === this.state.selectedSource.toString()

                }
            )
            this.setState({
                user: this.props.user,
                selectedSourceFull
            })
        }
        // if (this.state.passedTop !== this.props.passedTop ||
        //     this.state.show !== this.props.show ||
        //     this.state.scrollPos !== this.props.scrollPos) {
        //     this.setState({
        //         passedTop: this.props.passedTop,
        //         show: this.props.show,
        //         scrollPos: this.props.scrollPos
        //     })
        // }
    }

    addDefaultSrc = (ev) => {
        ev.target.src = 'https://4.bp.blogspot.com/-zsbDeAUd8aY/US7F0ta5d9I/AAAAAAAAEKY/UL2AAhHj6J8/s640/facebook-default-no-profile-pic.jpg';
    }
    toggleMenu = () => {
        if (this.state.isOpen === false) {
            this.setState({
                isOpen: true
            })
        } else {
            this.setState({
                isOpen: false
            })
        }
    }
    closeProfileSettingsMenu = (e) => {
        let clickedElement = e.target;
        if (document.querySelector('.profile-settings-dropdown')) {
            let profileDropdown = document.querySelector('.profile-settings-dropdown');
            let profileToggle = document.querySelector('#profile-menu');
            let profileImage = document.querySelector('.profile-pic');
            let profileArrow = document.querySelector('.menu-arrow');
            if (!profileDropdown.contains(clickedElement)) {
                if ((clickedElement !== profileToggle && clickedElement !== profileImage && clickedElement !== profileArrow) && !this.state.pauseClosing) {
                    //console.log('close emoji');
                    this.setState({
                        isOpen: false,
                        openProfileFromMain: false
                    })
                }
            }
        }
    }

    render() {
        //console.log('top header rendering')
        let sources = this.props.sources || [];
        //let feeds_shared = this.props.feeds_shared || [];
        //console.log("sources", sources);
        let selectedSource = this.state.selectedSource || "";
        let selected_source_rss = this.state.selected_source_rss || "";
        let source_active = this.state.source_active || false;
        let optionsSources = [];
        let countOptionsSources = 0;
        let source_name = "";
        //console.log("selectedSource", selectedSource);
        sources.forEach(function (entry) {
            optionsSources[countOptionsSources] = {value: entry.id, text: entry.name};
            countOptionsSources++;
            if (entry.id.toString() === selectedSource.toString()) {
                source_name = entry.name;
            }

        });
        // feeds_shared.forEach(function (entry) {
        //     optionsSources[countOptionsSources] = {value: entry.id, text: entry.name};
        //     countOptionsSources++;
        //     //console.log('entry: ', entry);
        //
        //     let entryId = ''
        //     if (entry.id) {
        //         entryId = entry.id
        //     }else {
        //         entryId = entry.project_id
        //     }
        //     if (entryId.toString() === selectedSource.toString()) {
        //         source_name = entry.name;
        //     }
        //
        // });
        optionsSources[countOptionsSources] = {value: "add-feed-source", text: 'Create your first project'};
        countOptionsSources = 0;
        // console.log("optionsSources", optionsSources);

        let selectedSourceNode = this.props.selectedSourceNode;

        return (

            <header id="top-header" className=
                {
                    `
                    ${this.state.passedTop ? this.state.show ? 'active' : 'non-active' : ''}
                    ${window.location.href.indexOf("sms-inbox") > -1 ? 'sms-inbox-header' : ''}
                    ${selectedSourceNode && selectedSourceNode.business_verification && selectedSourceNode.business_verification &&
                    selectedSourceNode.business_verification.status === 'verified' && this.props.doNotShowSuccessCallout ? '' :
                        selectedSourceNode ? 'margin-top-header' : ''}
                    `
                }
            >

                <div onClick={this.props.onClickHam} id='ham' className='ham-menu-icon'>

                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div className="header-right-side">
                    <div className='profile-data-container'>
                        {this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].viber_client !== null ?
                            <div id='viber' className="balance-container">
                                <div>
                                    Viber credits
                                    <p>{
                                        this.state.selectedSourceFull[0].viber_client ?
                                            this.state.selectedSourceFull[0].viber_client.available_credit ?
                                                this.state.selectedSourceFull[0].viber_client.available_credit.slice(-1) === '$' ?
                                                    Number(this.state.selectedSourceFull[0].viber_client.available_credit.slice(0, -1)) :
                                                    Number(this.state.selectedSourceFull[0].viber_client.available_credit).toFixed(0)
                                                : '0'
                                            : '0'
                                    }</p>
                                </div>
                            </div>
                            : ''}

                        {this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].project_balance !== null ?
                            <div id='project' className="balance-container">
                                <div>
                                    Balance
                                    <p>
                                        {Number(this.state.selectedSourceFull[0].project_balance.credits).toFixed(0)}
                                    </p>
                                </div>
                            </div>
                            :

                            <div id='project' className="balance-container">
                                <div>
                                    Balance
                                    <p>
                                        0

                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                    <Link to='/top-up/add-credits'>
                        <button className='btn-action'>Top-Up</button>
                    </Link>

                    <Popover
                        ref={menu => this.menuItem = menu}
                        position={Position.BOTTOM}
                        interactionKind={PopoverInteractionKind.CLICK}
                        className='profile-popover'
                        isOpen={this.state.isOpen || this.state.openProfileFromMain}
                    >
                        <div onClick={this.toggleMenu} className='onboarding-tour-step-3 first-workspace-tour-step-13'
                             id="profile-menu">

                            <img onClick={this.toggleMenu} className="profile-pic"
                                 src={this.props.profile_photo || "/img/default-user.jpg"} alt="Emitto"/>
                            <span onClick={this.toggleMenu} className="menu-arrow fas fa-sort-down popover-10">
                            </span>
                        </div>
                        <ul className='profile-settings-dropdown padding-10 first-workspace-tour-step-14'>
                            <li>
                                <NavLink onClick={this.toggleMenu} to="/edit-profile"

                                         style={{display: "block"}}>Edit Profile
                                </NavLink>
                            </li>
                            <li className=''>
                                <NavLink onClick={this.toggleMenu} to="/teams"
                                         style={{display: "block"}}>Teams</NavLink>
                            </li>
                            <li className='first-workspace-tour-step-15'>
                                <NavLink onClick={this.toggleMenu} to="/billing/balance"
                                         style={{display: "block"}}>Billing</NavLink>
                            </li>
                            <li>
                                <a href="/logout" style={{display: "block"}}>Log Out</a>
                            </li>
                        </ul>

                    </Popover>
                </div>
            </header>
        )
    }

}

export default TopHeader